import React, { useState } from "react";
import {
  Grid,
  Paper,
  Avatar,
  TextField,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import LockIcon from "@mui/icons-material/Lock";
import { pink } from "@mui/material/colors";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { updatePassword } from "../../services/Auth";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
    width: "60vh",
    margin: "20vh auto",
  },
  header: {
    marginTop: "0px",
  },
  headerTxt: {
    marginTop: "0px",
  },
});

function ResetPassword() {
  const classes = useStyles();
  const history = useHistory();
  const { email, token } = useParams();

  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState(
    "Password reset link sent. Check your inbox."
  );

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    setError("");
    setSuccessMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (values.password !== values.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!token) {
      setError("Invalid or missing token.");
      return;
    }

    try {
      console.log("Step 1...");
      //set payload values...
      const payload = {
        email: email,
        password: values.password,
        token: token,
      };
      console.log("values--", payload);
      //call update password API
      const result = await updatePassword(payload);
      if (result === "success") {
        console.log("Done..");
        setSuccessMessage("Password reset successful. You can now log in.");
        setTimeout(() => history.push("/"), 3000);
      } else {
        setError(result || "Failed to reset password.");
      }
    } catch (err) {
      console.log("error", err);
      setError("Something went wrong. Try again later.");
    }
  };

  return (
    <Grid>
      <Paper elevation={10} className={classes.paper}>
        <Grid align="center" className={classes.header}>
          <h2>NORTEL (PVT) LTD</h2>
          <Avatar sx={{ bgcolor: pink[500] }}>
            <LockIcon />
          </Avatar>
          <h3 className={classes.headerTxt}>Reset Password</h3>
        </Grid>

        {error && (
          <Typography
            align="left"
            variant="caption"
            style={{ color: "red", fontSize: 16, fontWeight: "bold" }}
          >
            {error}
          </Typography>
        )}
        {successMessage && (
          <Typography
            align="left"
            variant="caption"
            style={{ color: "green", fontSize: 16, fontWeight: "bold" }}
          >
            {successMessage}
          </Typography>
        )}

        <Stack direction="column" spacing={2}>
          <TextField
            label="New Password"
            name="password"
            type="password"
            fullWidth
            required
            value={values.password}
            onChange={handleChange}
          />
          <TextField
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            required
            value={values.confirmPassword}
            onChange={handleChange}
          />
          <Button variant="contained" fullWidth onClick={handleSubmit}>
            Reset Password
          </Button>
        </Stack>

        <Typography align="center" sx={{ m: 2 }}>
          Go back to <a href="/">Login</a>
        </Typography>
      </Paper>
    </Grid>
  );
}

export default ResetPassword;
